import cn from 'classnames';
import React from 'react';

interface Props {
  src: string;
  className?: string;
}

export const VideoPlayer = ({ src, className }: Props) => (
  <video controls src={src} className={cn(className, 'rounded-xl')} />
);
